<template>
  <div
    id="page"
    v-loading="loading"
    element-loading-text="加载中"
    element-loading-background="rgba(0, 0, 0, 0.2)"
  >
    <div class="header">
      <div class="system_name">
        <img src="@/assets/img/logo_w@2x.png" class="titile_logo" alt="" />
        <span>玉州区米粉全产业链综合服务平台</span>
      </div>
      <div class="help" @click="quit">退出</div>
      <div class="user_info">
        <el-avatar :size="30" icon="el-icon-user-solid"></el-avatar>
        <!-- <el-avatar :size="60" src="https://empty"> </el-avatar> -->
        <div class="user_name">{{ name }}</div>
      </div>
    </div>
    <div class="container">
      <div class="aside">
        <NavMenu :menuArr="menuArr" v-if="menuArr.length != 0" />
      </div>
      <div class="main">
        <router-view :key="$route.path" />
      </div>
    </div>
  </div>
</template>

<script>
import NavMenu from "./NavMenu/NavMenu.vue";
import commonApi from "@/api/commonApi";
import loginApi from "@/api/sys_setting/loginApi";
import { mapMutations } from "vuex";

export default {
  components: { NavMenu },
  data() {
    return {
      menuArr: [],
      name: "",
      loading: true,
    };
  },
  provide() {
    return {
      getMenuAndOperate: this.getMenuAndOperate,
    };
  },
  computed: {},
  created() {
    // this.menuArr = localStorage.getItem("menus")
    //   ? JSON.parse(localStorage.getItem("menus"))
    //   : [];
    // if (this.menuArr) {
    //   this.loading = false;
    //   return;
    // }
    setTimeout(() => {
      this.getMenuAndOperate();
    }, 1000);
  },
  mounted() {
    this.name = localStorage.getItem("userName");
  },

  methods: {
    ...mapMutations(["setPermissionList"]),
    quit() {
      this.$confirm("此操作将退出本次登录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          loginApi.logout().then((res) => {
            if (res.data.code == "00") {
              this.$message({
                showClose: true,
                type: "success",
                message: "退出成功！",
              });
              localStorage.removeItem("isLogin");
              localStorage.removeItem("poor_prevent_userName");
              localStorage.removeItem("sysdivisionNum");
              localStorage.removeItem("poor_prevent_divisionName");
              localStorage.removeItem("divisionName");
              localStorage.removeItem("showFlag");
              localStorage.removeItem("achievement_token");
              sessionStorage.clear();
              this.$router.replace({ path: "/login" });
            } else {
              this.$message({
                showClose: true,
                type: "error",
                message: res.data.detail ? res.data.detail : res.data.message,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            showClose: true,
            type: "info",
            message: "已取消",
          });
        });
    },
    // 获取菜单和功能操作权限
    getMenuAndOperate() {
      this.loading = true;
      //  management_system
      commonApi.menuTree("management_system").then((res) => {
        if (res.data.code == "00") {
          var map = {};
          this.getOperate(res.data.rows, map);
          this.setPermissionList({ data: map });
          this.menuArr = this.getMenuFilter(res.data.rows);
          // localStorage.setItem("permissionList", JSON.stringify(map));
          // localStorage.setItem("menus", JSON.stringify(this.menuArr));
          this.loading = false;
        } else {
          this.$message({
            showClose: true,
            type: "error",
            message: res.data.detail ? res.data.detail : res.data.message,
          });
        }
      });
    },
    // 过滤菜单
    getMenuFilter(menus) {
      if (menus == undefined || menus.length == 0) {
        return [];
      }
      let menu = menus.filter((e) => e.kind == 0);
      menu.forEach((item) => {
        item.children = this.getMenuFilter(item.children);
      });
      return menu;
    },
    // 过滤功能操作
    getOperate(menus, map) {
      if (menus == undefined || menus.length == 0) {
        return;
      }
      menus.forEach((item) => {
        if (item.children) {
          var opts = item.children.filter((e) => e.kind == 1);
          if (opts && opts.length > 0) {
            map[item.menuKey] = item.children.filter((e) => e.kind == 1); //只存有功能操作的
          }
          this.getOperate(
            item.children.filter((e) => e.kind != 1),
            map
          );
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#page {
  display: flex;
  flex-direction: column;
  height: 100vh;
  .header {
    height: 90px !important;
    z-index: 100;
    background: #1f2227;
    box-shadow: 0px 3px 4px 1px rgba(37, 161, 103, 0.1);
    flex-shrink: 0;
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #ffffff;
    .system_name {
      font-size: 23px;
      padding-left: 70px;
      font-family: Microsoft YaHei-Bold, Microsoft YaHei;
      font-weight: bold;
      flex: 1;
      display: flex;
      align-items: center;
      .titile_logo {
        margin-right: 20px;
        width: 32px;
      }
    }
    .help {
      cursor: pointer;
    }
    .user_info {
      margin-left: 30px;
      margin-right: 60px;
      display: flex;
      align-items: center;
      .user_name {
        margin-left: 8px;
      }
    }
  }
  .container {
    flex: 1;
    height: calc(100vh - 90px);
    display: flex;
    .aside {
      background: #ffffff;
      box-shadow: 0px 0px 6px 1px #dce0e6;
      width: 315px;
      height: 100%;
      overflow: auto;
    }
    .main {
      flex: 1;
      height: 100%;
      overflow: auto;
      box-sizing: border-box;
      padding: 24px 20px 40px 34px;
    }
  }
}
</style>
